import { gql } from '@apollo/client';

export const GET_REVIEWS_AND_RATINGS = gql`
	query GetProductReviews($productId: String!) {
		getProductReviews(productId: $productId) {
			reviewId
			productId
			productName
			userNickname
			reviewTitle
			reviewSubmissionTime
			reviewText
			starRatings
		}
	}
`;
